export default "__VITE_ASSET__Ca6gd0fm__"